import React, { useState, useRef, useEffect } from 'react';
import './MultiSelectFilter.css';

const MultiSelectFilter = ({ 
    label, 
    options, 
    selectedValues, 
    onChange 
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleToggle = (value) => {
        const newValues = selectedValues.includes(value)
            ? selectedValues.filter(v => v !== value)
            : [...selectedValues, value];
        onChange(newValues);
    };

    const handleSelectAll = () => {
        onChange(options.map(opt => opt.value));
    };

    const handleClearAll = () => {
        onChange([]);
    };

    const getDisplayText = () => {
        if (selectedValues.length === 0) {
            return `All ${label}`;
        }
        if (selectedValues.length === options.length) {
            return `All ${label}`;
        }
        if (selectedValues.length === 1) {
            const selected = options.find(opt => opt.value === selectedValues[0]);
            return selected ? selected.label : `${label} (1)`;
        }
        return `${label} (${selectedValues.length})`;
    };

    return (
        <div className="multi-select-filter" ref={dropdownRef}>
            <button 
                className="multi-select-button"
                onClick={() => setIsOpen(!isOpen)}
            >
                {getDisplayText()}
                <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
            </button>
            
            {isOpen && (
                <div className="multi-select-dropdown">
                    <div className="multi-select-actions">
                        <button onClick={handleSelectAll} className="action-btn">Select All</button>
                        <button onClick={handleClearAll} className="action-btn">Clear All</button>
                    </div>
                    <div className="multi-select-options">
                        {options.map(option => (
                            <label key={option.value} className="multi-select-option">
                                <input
                                    type="checkbox"
                                    checked={selectedValues.includes(option.value)}
                                    onChange={() => handleToggle(option.value)}
                                />
                                <span>{option.label}</span>
                            </label>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MultiSelectFilter;
